import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.CROPS]
		.GET_CROPS]: {
		url: '/company/:companyId/crops/',
	},
	[ModulesConfigMap[ModulesMap.CROPS]
		.GET_CROP_POPUP]: {
		url: '/company/:companyId/crops/:cropsId/popup/',
	},
	[ModulesConfigMap[ModulesMap.CROPS]
		.GET_CROP_PREVIEW]: {
		url: '/company/:companyId/crops/:cropsId/preview/',
	},
	[ModulesConfigMap[ModulesMap.CROPS]
		.GET_CROP]: {
		url: '/company/:companyId/crops/:cropsId/',
	},
	[ModulesConfigMap[ModulesMap.CROPS]
		.CREATE_CROP]: {
		url: '/company/:companyId/crops/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.CROPS]
		.PATCH_CROP]: {
		url: '/company/:companyId/crops/:cropsId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.CROPS]
		.PUT_CROP]: {
		url: '/company/:companyId/crops/:cropsId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.CROPS]
		.DELETE_CROP]: {
		url: '/company/:companyId/crops/:cropsId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
